import { createContext } from 'react';

export const RestaurantOrderContext = createContext({});